const EN = {
    title: 'Expirations',
    table: {
        title: 'Expirations list',
        columns: {
            id: 'Intern ID',
            client: 'Client',
            document: 'INE',
            lastFour: 'Last four',
            balance: 'Closing balance'
        },
        closingGroups: {
            53: 'Closing group 53',
            54: 'Closing group 54',
            55: 'Closing group 55',
            56: 'Closing group 56',
            openButton: 'Open',
            closeButton: 'Close',
        },
        details: {
            cards: 'Cards',
            totalBalance: 'Total balance',
            closingDate: 'Closing date',
            expirationDate: 'Expiration date',
        }
    }
};

export default EN;
